import { useContext } from "react";
import { OnProgressProps } from "react-player/base";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import getAbsoluteTimeFromRelativeTime from "../utils/getAbsoluteTimeFromRelativeTime";

export default function useOnProgress(
  onProgress?: (progress: OnProgressProps) => void,
) {
  const {
    isScrubbing,
    isBeingModified,
    player,
    setSeekToAbsolutePosition,
    timelineItemIndex,
    timelinePositions,
    seekToAfterPlayerInit,
    setSeekToAfterPlayerInit,
    setAbsoluteTime,
  } = useContext(TimelinePlayerContext);

  return (progress: OnProgressProps) => {
    if (isScrubbing || isBeingModified) return;
    if (onProgress) onProgress(progress);
    if (seekToAfterPlayerInit != undefined) {
      setSeekToAbsolutePosition(seekToAfterPlayerInit);
      setSeekToAfterPlayerInit(undefined);
      return;
    }

    const relativeTime = player?.getCurrentTime() ?? progress.playedSeconds;

    setAbsoluteTime(
      getAbsoluteTimeFromRelativeTime(
        relativeTime,
        timelineItemIndex,
        timelinePositions,
      ),
    );
  };
}
